import { render, staticRenderFns } from "./OrderBuyerDeatil.vue?vue&type=template&id=2e79f26c&scoped=true&"
import script from "./OrderBuyerDeatil.vue?vue&type=script&lang=js&"
export * from "./OrderBuyerDeatil.vue?vue&type=script&lang=js&"
import style0 from "./OrderBuyerDeatil.vue?vue&type=style&index=0&id=2e79f26c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e79f26c",
  null
  
)

export default component.exports